import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const initialState = {
    marketPlaceList: [],
    isMarketPlaceLoaded: false,
    isMarketPlaceDelete: false,
    marketPlaceTypesList: [],
    isMarketPlaceTypesLoaded: false,
    marketPlaceAllList: [],
    isMarketPlaceAllLoaded: false,
}

const marketPlaceSlice = createSlice({
    name: 'MarketPlace',
    initialState,
    reducers: {
        setScrollId(state, action) {
            state.scrollId = action.payload.scrollId;
        }
    },
    extraReducers: (builder) => {
        // Get  MarketPlace
        builder.addCase(actions.getMarketPlace.pending, (state) => {
            state.isMarketPlaceLoaded = false;
        })
        builder.addCase(actions.getMarketPlace.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.marketPlaceList = action.payload.data;
            } else {
                state.marketPlaceList = [];
            }
            state.isMarketPlaceLoaded = true;
        })
        builder.addCase(actions.getMarketPlace.rejected, (state) => {
            state.isMarketPlaceLoaded = false;
        });


        // Get All  MarketPlace  list
        builder.addCase(actions.getMarketPlaceList.pending, (state) => {
            state.isMarketPlaceAllLoaded = false;
        })
        builder.addCase(actions.getMarketPlaceList.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.marketPlaceAllList = action.payload.data;
            } else {
                state.marketPlaceAllList = [];
            }
            state.isMarketPlaceAllLoaded = true;
        })
        builder.addCase(actions.getMarketPlaceList.rejected, (state) => {
            state.isMarketPlaceAllLoaded = false;
        });

        //delete 
        builder.addCase(actions.deleteMarketPlace.pending, (state) => {
            state.isMarketPlaceDelete = true;
        })
        builder.addCase(actions.deleteMarketPlace.fulfilled, (state, action) => {
            if (action.payload.success) {
                const id = action.payload.data;
                state.marketPlaceAllList = state.marketPlaceAllList.filter(item => item.baseId !== id);
                state.marketPlaceList = state.marketPlaceList.filter(item => item.baseId !== id);
            }
            state.isMarketPlaceDelete = false;
        })
        builder.addCase(actions.deleteMarketPlace.rejected, (state) => {
            state.isMarketPlaceDelete = false;
        });

        //Get MarketPlace Types List  

        builder.addCase(actions.getMarketPlaceTypes.pending, (state) => {
            state.isMarketPlaceTypesLoaded = false;
        })
        builder.addCase(actions.getMarketPlaceTypes.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.marketPlaceTypesList = action.payload.data;
            } else {
                state.marketPlaceTypesList = [];
            }
            state.isMarketPlaceTypesLoaded = true;
        })
        builder.addCase(actions.getMarketPlaceTypes.rejected, (state) => {
            state.isMarketPlaceTypesLoaded = false;
        });
    }
});

export const { setScrollId } = marketPlaceSlice.actions

export default marketPlaceSlice.reducer;